/* global window */
import { useEffect, useRef } from "react";

const MousePositionTracker = () => {
  const mousePositionRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const updateMousePosition = (e) => {
      mousePositionRef.current = { x: e.clientX, y: e.clientY };
    };

    window.addEventListener("mousemove", updateMousePosition);
    return () => window.removeEventListener("mousemove", updateMousePosition);
  }, []);

  // Expose the mouse position through a global ref
  window.mousePositionRef = mousePositionRef;

  return null;
};

export default MousePositionTracker;
